import { Link } from "react-router-dom";

/**
 * Página 404 para rutas inexistentes fuera del flujo principal.
 */
export default function NotFound() {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center bg-[rgb(var(--bg))] px-6 text-center">
      <p className="mb-3 text-6xl">🔍</p>
      <h1 className="font-display text-3xl font-semibold text-[rgb(28_23_20)]">Page not found</h1>
      <p className="mt-3 max-w-sm text-[rgb(84_72_62)]">
        The page you tried to open does not exist. You can return to your invite dashboard instead.
      </p>
      <Link
        to="/"
        className="btn-primary mt-8 rounded-full px-6 py-3 font-semibold"
      >
        Back to My Invites
      </Link>
    </main>
  );
}
